export default __webpack_public_path__ + "static/media/sedated.86493569.svg";